import API from '@Services/apiAxios';

export const DOCUMENT_TYPE = 'shipment'; // Flexible configuration for changing it later in one place

export interface ExtractionResponse {
  message?: string;
  state?: string;
  [key: string]: any;
}

export const extractDocument = async (s3Key: string): Promise<ExtractionResponse> => {
  const response = await API.post<ExtractionResponse>('/speedboxbot/extract', {
    documentType: DOCUMENT_TYPE,
    s3Key,
  });
  return response.data;
};

export const extractTextDetails = async (textContent: string): Promise<ExtractionResponse> => {
  const response = await API.post<ExtractionResponse>('/speedboxbot/extract', {
    documentType: DOCUMENT_TYPE,
    textContent,
  });
  return response.data;
};

export interface StartBatchExtractionResponse {
  batchId: string;
  [key: string]: any;
}

export interface BatchExtractionStatusResponse {
  batchId: string;
  status: string;
  progress?: number;
  result?: any;
  message?: string;
  [key: string]: any;
}

export const startBatchExtraction = async (batchId: string, files: string[]): Promise<StartBatchExtractionResponse> => {
  const { data } = await API.post<StartBatchExtractionResponse>('/speedboxbot/extract/batch', {
    batchId,
    documentType: DOCUMENT_TYPE,
    files,
  });
  return data;
};

export const getBatchExtractionStatus = async (batchId: string): Promise<BatchExtractionStatusResponse> => {
  const { data } = await API.get<BatchExtractionStatusResponse>(`/speedboxbot/extract/batch/${batchId}`);
  return data;
};

export const pollBatchStatus = (
  batchId: string,
  onProgress: (status: BatchExtractionStatusResponse) => void,
  cancelRef: { cancelled: boolean },
  intervalMs = 3000,
): Promise<BatchExtractionStatusResponse> => {
  return new Promise((resolve, reject) => {
    const run = async () => {
      if (cancelRef.cancelled) {
        reject(new Error('Batch extraction polling cancelled.'));
        return;
      }
      try {
        const response = await getBatchExtractionStatus(batchId);
        if (cancelRef.cancelled) {
          reject(new Error('Batch extraction polling cancelled.'));
          return;
        }
        onProgress(response);

        const status = response.status?.toLowerCase();
        if (status === 'completed' || status === 'success') {
          resolve(response);
        } else if (status === 'failed' || status === 'error') {
          reject(new Error(response.message || 'Batch extraction failed.'));
        } else {
          setTimeout(run, intervalMs);
        }
      } catch (error) {
        reject(error);
      }
    };
    run();
  });
};
